import { getEnumValues } from "@common/enumOperations";

// Mirrors the backend Core.DomainModels.Risk.AssessmentConfidence enum (numeric, stored as INT).
export enum AssessmentConfidence {
    Low = 1,
    Moderate = 2,
    High = 3,
    VeryHigh = 4,
}

export const assessmentConfidenceTranslationKey: Record<AssessmentConfidence, string> = {
    [AssessmentConfidence.Low]: "assessmentConfidenceLow",
    [AssessmentConfidence.Moderate]: "assessmentConfidenceModerate",
    [AssessmentConfidence.High]: "assessmentConfidenceHigh",
    [AssessmentConfidence.VeryHigh]: "assessmentConfidenceVeryHigh",
};

export function getAssessmentConfidenceOptions(translateString: (key: string) => string) {
    return getEnumValues(AssessmentConfidence).map((confidence) => ({
        id: confidence.toString(),
        name: translateString(assessmentConfidenceTranslationKey[confidence]),
    }));
}
